<!-- @format -->

@if (loaded$ | async) {
  <!-- OnPush change detector gets triggered (only) when this observable emits. Conditional function bindings were a performance hit without this. -->
  <span class="tiny-badge" [ngClass]="getStatusBadgeColor()" data-cy="study-right-status">
    {{ "PROFILE.STATE." + currentState | translate }}
    @if (getStateSpecifier(); as stateSpecifier) {
      <span> - {{ stateSpecifier | translate }}</span>
    }
  </span>
  @if (hasUpcomingTransferOutDate()) {
    <span class="tiny-badge secondary">
      {{ "PROFILE.TRANSFERS_OUT_AT" | translate: { date: (studyRight.transferOutDate | localDateFormat) } }}
    </span>
  }
  @if (tuitionFeeObligationPeriods.length) {
    <span class="tiny-badge accent">
      {{ "STUDY_RIGHTS.TUITION_FEE_OBLIGATION_PERIODS.PAID" | translate }}
    </span>
  }
}
